import { render, staticRenderFns } from "./pointImport.vue?vue&type=template&id=1cc207d2&scoped=true&"
import script from "./pointImport.vue?vue&type=script&lang=js&"
export * from "./pointImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc207d2",
  null
  
)

export default component.exports